import { useAllEdges, useProjectOf, useProjects, useTasksByState } from '@/db/hooks'
import { withSteps } from '@/lib/steps'
import { useListNav } from '@/hooks/useKeyboard'
import { isTemplate } from '@/kinds/task'
import { taskActions } from '@/lib/actions'
import { TaskRow } from '@/components/TaskRow'
import { Button, Empty, PageTitle } from '@/components/ui'
import { AppTabs, REVIEW_TABS } from '@/components/AppTabs'

export const SomedayView = () => {
  const tasks = (useTasksByState('someday') ?? [])
    .filter((t) => !isTemplate(t.spec))
    .sort((a, b) => (a.status.last_touched < b.status.last_touched ? 1 : -1))
  const ordered = withSteps(tasks, useAllEdges())
  const cursor = useListNav(ordered.map((x) => x.task.id))
  const projects = useProjects() ?? []
  const byId = new Map(projects.map((p) => [p.id, p]))
  const projectOf = useProjectOf()
  return (
    <div>
      <PageTitle>Review</PageTitle>
      <AppTabs tabs={REVIEW_TABS} label="Review" />
      {tasks.length === 0 ? (
        <Empty>Nothing parked here.</Empty>
      ) : (
        // one surface, the way out of Someday inside each row (it hung off a card per row)
        <ul className="group-list" data-testid="someday-list">
          {ordered.map(({ task: t, child }, i) => (
            <TaskRow
              key={t.id}
              task={t}
              index={i}
              focused={cursor === i}
              mode="compact"
              child={child}
              project={byId.get(projectOf.get(t.id) ?? '')}
              trailing={
                <Button variant="chip" onClick={() => void taskActions.move(t, 'next')}>
                  Make it next
                </Button>
              }
            />
          ))}
        </ul>
      )}
    </div>
  )
}
